import { IsArray, IsDefined, IsInt, IsNumber, IsOptional, IsString } from 'class-validator';

export class SearchWastageDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  year: number;

  @IsOptional()
  @IsInt()
  weekNo?: number;

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryIdList?: number[];

  @IsOptional()
  @IsString()
  wastageDay?: string;
}
